<template>
    <v-flex>
        <h3>{{WelcomeConstants.GET_STARTED}} &nbsp;&nbsp;&nbsp;
            <span v-if="canEdit">
                <strong class="manage_videos"
                        data-qe-id="open_manage_video_btn"
                        @click="openManageVideos()">
                    <span>Manage Videos</span>
                </strong>
            </span>
        </h3>
        <v-flex class="v-carousel__block">
            <v-flex v-if="loadAction.pending" justify-center text-xs-center>
                <v-progress-circular indeterminate color="grey"></v-progress-circular>
            </v-flex>
            <v-flex v-if="loadAction.failed" justify-center text-xs-center>
                {{WelcomeConstants.ERROR_LOADING}}
            </v-flex>
            <v-flex v-if="!loadAction.pending && takeTourVideos && !(takeTourVideos.length > 0)" justify-center text-xs-center>
                {{WelcomeConstants.NO_VIDEOS}}
            </v-flex>
            <v-carousel
                :cycle="false"
                hide-controls
                light
                v-if="takeTourVideos.length > 0"
                prev-icon="chevron_left"
                next-icon="chevron_right"
                transition="fade">
                <v-carousel-item v-for="(num,index) in countOfVideos" :key="index">
                    <v-layout row wrap>
                        <v-flex
                            xs12
                            sm3
                            md3
                            v-for="(video, j) in getChunks(index*partitionSize, partitionSize)"
                            :key="j"
                            :data-qe-id="`carousel_video_${index}`"
                            @click="showVideoCarousel(video, index+j)">
                            <v-flex class="video-block">
                                <v-flex class="video-block__video">
                                    <video width="100%">
                                        <source :src="video.url" type="video/mp4">
                                    </video>
                                </v-flex>
                                <strong :title="video.title">{{ video.title }}</strong>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-carousel-item>
            </v-carousel>
            <v-flex>
                <v-dialog v-model="OpenDialogBox" persistent content-class="medium">
                    <manage-videos :can-edit="canEdit" @close="closeDialogState" @bind="bindTourVideos"></manage-videos>
                </v-dialog>
                <v-dialog scrollable v-model="openVideo.openVideoCarousel" content-class="medium">
                    <video-carousel
                        v-if="openVideo.openVideoCarousel"
                        :open-video="openVideo"
                        :take-tour-videos="takeTourVideos"
                        :take-tour-preview-video="takeTourPreviewVideo"
                        :take-tour-title="takeTourTitle"></video-carousel>
                </v-dialog>
            </v-flex>
        </v-flex>
    </v-flex>
</template>

<script>
    import { WelcomeConstants } from "../AssistPage/AssistPageConstants";
    import VideoCarousel from "../AssistPage/VideoCarousel";
    import StatusOverlay from "../StatusOverlay/StatusOverlay";
    import { mapGetters, mapActions, mapState } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant.js";
    import ManageVideos from "../AssistPage/ManageVideos";

    
    export default {
        name: "TakeATour",
        components: {
            VideoCarousel,
            StatusOverlay,
            ManageVideos,
        },
        created() {
            this.getTakeTourVideos();
        },
        data: () => ({
            WelcomeConstants,
            partitionSize: 4,
            openVideo: {
                openVideoCarousel: false,
            },
            takeTourTitle: "",
            takeTourPreviewVideo: [],
            OpenDialogBox: false,
        }),
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                takeTourVideos: `assistPage/${storeGetters.takeTourVideos}`,
                canEdit: `assistPage/${storeGetters.canEditTakeTourVideos}`,
            }),
            countOfVideos() {
                return Math.ceil(this.takeTourVideos.length / this.partitionSize);
            },
            loadAction() {
                return this.actions[storeAction.getTakeTourVideos];
            },
            cardPages() {
                // xl = 12, lg = 6, md = 4, sm = 3, xl = 2
                let pageSize = 4;
                if (this.$vuetify.breakpoint.xl) {
                    pageSize = 4;
                } else if (this.$vuetify.breakpoint.lg) {
                    pageSize = 4;
                } else if (this.$vuetify.breakpoint.md) {
                    pageSize = 4;
                } else if (this.$vuetify.breakpoint.sm) {
                    pageSize = 3;
                } else if (this.$vuetify.breakpoint.xs) {
                    pageSize = 1;
                }

                const pages = [];
                for (let i = 0; i < this.takeTourVideos.length; i += 1) {
                    pages.push(this.takeTourVideos.slice(i, i + pageSize));
                    // if (pageSize < 3) {
                    //
                    // }
                    // if (this.$vuetify.breakpoint.xs) {
                    //     pageSize = 1;
                    // }
                }
                return pages;
            },
        },
        methods: {
            getChunks(startIndex, size) {
                return this.takeTourVideos.slice(startIndex, startIndex + size);
            },
            openManageVideos() {
                this.OpenDialogBox = true;
            },
            closeDialogState() {
                this.OpenDialogBox = false;       
            },
            bindTourVideos() {
                this.getTakeTourVideos();
            },
            showVideoCarousel(taketour, index) {
                this.takeTourTitle = taketour.title;
                this.openVideo.openVideoCarousel = true;
                this.takeTourPreviewVideo = [];
                this.takeTourPreviewVideo.push(taketour);
                const tourLength = this.takeTourVideos.length - 1;
                if (tourLength > index) {
                    for (let i = index + 1; i <= tourLength; i += 1) {
                        this.takeTourPreviewVideo.push(this.takeTourVideos[i]);
                    }
                }
                for (let i = 0; i < index; i += 1) {
                    this.takeTourPreviewVideo.push(this.takeTourVideos[i]);
                }
            },
            videoTakenCount() {
                return this.$vuetify.breakpoint.xs ? 1 : 4;
            },
            getTourData(item) {
                return this.takeTourVideos.slice(item, item + this.videoTakenCount());
            },
            ...mapActions({
                getTakeTourVideos: `assistPage/${storeAction.getTakeTourVideos}`,
            }),
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .manage_videos {
        cursor: pointer;
    }

    .assistPage {
        margin-top: 64px;

        h2,
        h3,
        .v-expansion-panel__body,
        .v-expansion-panel__header {
            font-family: "Raleway", sans-serif;
        }

        h2 {
            color: $ypo-blue;
            margin: 0px 0 40px 0;
            padding: 30px 0 10px 0;
            border-bottom: 1px solid $ypo-blue;
            font-weight: 400;
            font-size: 24px;
            position: relative;

            .v-btn {
                position: absolute;
                right: 0;
                bottom: 10px;
                margin: 0;
            }
        }

        h3 {
            font-size: 22px;
            color: $ypo-blue;
            font-weight: 500;
            margin: 10px 0;
        }

        .v-carousel {
            margin-top: 15px;

            @include breakpoint(xs) {
                &__block {
                    margin: 0 7px;
                }
            }

            strong {
                color: $ypo-cta;
                font-size: 18px;
                line-height: 30px;
                font-weight: 500;
                padding: 7px 10px 7px 10px;
                display: block;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                cursor: pointer;
            }

            .v-item-group {
                .v-icon {
                    color: transparent;
                    border: 1px solid $ypo-blue;
                    border-radius: 50%;
                    padding: 0;
                    font-size: 16px !important;
                    opacity: 1;
                }

                .v-btn--active:before,
                .v-btn:hover:before,
                .v-btn:focus:before {
                    background: transparent;
                }

                .v-btn--active {
                    .v-icon {
                        background: $ypo-blue;
                    }
                }
            }

            .video-block {
                margin: 0 5px;
                background: $ypo-extra-light-gray;
                margin-bottom: 60px;
                box-shadow: 0 1px 3px 0 rgba($black, 0.18);

                &__video {
                    position: relative;

                    &:after {
                        content: "\f144";
                        position: absolute;
                        font-family: "Font Awesome 5 Free";
                        font-size: 50px;
                        color: rgba($white, 0.9);
                        z-index: 11;
                        left: 0;
                        right: 0;
                        top: 0;
                        cursor: pointer;
                        height: 100%;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        background: rgba($ypo-blue, 0.4);
                    }

                }

                &__title {
                    min-height: 60px;

                }
            }
        }

        .v-carousel,
        .v-carousel__item {
            height: auto !important;
            box-shadow: none;
        }

        .v-carousel__controls {
            background: transparent;

            &__item {
                margin: 0px !important;
            }
        }

        .v-window__container {
            height: auto !important;
        }

        @include breakpoint(md) {
            .v-carousel {
                strong {
                    font-size: 14px;
                    line-height: normal;
                }

            }
        }
    }
</style>
